$(document).ready(function(){


  const scrollertext = document.getElementById("scrollertext");
  if(scrollertext) {
      document.querySelectorAll('.scroll-box').forEach(box => {
          const inner = box.querySelector('.scroll-inner');
          const content = inner.querySelector('.scroll-content');
          const clone = content.cloneNode(true);
          inner.appendChild(clone);

          let pos = 0;
          let animationId = null;

          function animate() {
          pos -= 1;
          if (Math.abs(pos) >= content.offsetWidth) pos = 0;
          inner.style.transform = `translateX(${pos}px)`;
          animationId = requestAnimationFrame(animate);
          }

          animate();

          function startScroll() {
          if (!animationId) animate();
          }

          function stopScroll() {
          cancelAnimationFrame(animationId);
          animationId = null;
          }


          box.addEventListener('mouseenter', stopScroll);
          box.addEventListener('mouseleave', startScroll);
      });

      document.querySelectorAll('.scroll-box2').forEach(box => {
      const inner = box.querySelector('.scroll-inner');
      const content = inner.querySelector('.scroll-content');
      const clone = content.cloneNode(true);
      inner.appendChild(clone);

      let pos = -content.offsetWidth; // Start from the left (negative)
      let animationId = null;

      function animate() {
          pos += 1; // Reverse direction (scroll to right)
          if (pos >= 0) pos = -content.offsetWidth; // Reset once fully scrolled
          inner.style.transform = `translateX(${pos}px)`;
          animationId = requestAnimationFrame(animate);
      }

      animate(); // Start scroll initially

      function startScroll() {
          if (!animationId) animate();
      }

      function stopScroll() {
          cancelAnimationFrame(animationId);
          animationId = null;
      }

      box.addEventListener('mouseenter', stopScroll);
      box.addEventListener('mouseleave', startScroll);
      });
  } else {
      // console.log("scrollertext")
  }




  FlipClock.Lang.Custom = { days:'Days', hours:'Hours', minutes:'Minutes', seconds:'Seconds' };
  var opts = {
    clockFace: 'DailyCounter',
    countdown: true,
    language: 'Custom'
  };  
  var countdown = 1764575940 - ((new Date().getTime())/1000); // from: 11/28/2025 01:42 pm +0530
  countdown = Math.max(1, countdown);
  $('#black_friday_countdown').FlipClock(countdown, opts);


});